import React from 'react'
import Main from '../Main/Main'
import About from "../About/About";
import Servises from "../Servises/Servises";
import Individual from "../Individual/Individual";
//import MobileMenu from './MobileMenu/MobileMenu';
import Contacts from "../Contacts/Contacts";
import Cart from "../Cart/Cart";
import Reviews from '../Reviews/Reviews'



const Loyaut = () => {
  return (
    <div>
          <Main />
      <About />
      <Servises />
      <Individual />
      <Reviews/>
      <Cart/>
      <Contacts />
    </div>
  )
}

export default Loyaut
